module.exports = __webpack_public_path__ + "static/media/profile-1.c5f83581.png";